import React from 'react';
import Card from './Card';
import ImageGridx1 from '../portfolio/ImageGridx1';
import UnderConstruction from '../portfolio/UnderConstruction';

const Content_default = {
  sectionTitle: "Like what you see?",
  subtitle: "Find out more about me",
};

const Content_wip = {
  sectionTitle: "It takes time to write a story (or, Is it just me?)",
  subtitle: "You can message me a question instead of waiting.",
};

const WarpLarge = ({progressMode}) => (
  <section>
    { progressMode
      ? <aside className="hero hero--s">
          <div className="hero__inner">
            <ImageGridx1
            first="https://cdn.dribbble.com/users/124935/screenshots/3784748/simpler-spiral.gif"
            themeColor="#FAFFF0"/>
          </div>
          <div className="hero__inner extra-margin-top">
           <UnderConstruction/>
           <h3 className="slogan remove-margin-bottom">{Content_wip.sectionTitle}</h3>
           <p className="text-grey extra-padding-bottom">{Content_wip.subtitle}</p>
           <Card></Card>
         </div>
      </aside>
      : <aside className="hero hero--m">
          <div className="hero__inner">
            <h1 className="slogan remove-margin-bottom">{Content_default.sectionTitle}</h1>
            <p className="text-grey extra-padding-bottom">{Content_default.subtitle}</p>
            <Card></Card>
          </div>
      </aside>
    }
  </section>

);


export default WarpLarge;



// WEBPACK FOOTER //
// ./src/layout/warp/WarpLarge.js